// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'distribute-item-center-solid';

export const Component = () => (
  <path d='M16.702 4.406v15.709c0 .431-.143.766-.43 1.054a1.408 1.408 0 0 1-1.055.431H9.374c-.431 0-.766-.144-1.054-.431a1.408 1.408 0 0 1-.43-1.054V4.406c0-.431.143-.766.43-1.054a1.408 1.408 0 0 1 1.054-.43h5.843c.431 0 .767.143 1.054.43.288.288.431.623.431 1.054ZM2.958.48c0-.335-.144-.479-.48-.479C2.145 0 2 .144 2 .479v23.563c0 .335.144.48.479.48.335 0 .479-.145.479-.48V.48Zm19.636 0c0-.335-.144-.479-.48-.479-.334 0-.478.144-.478.479v23.563c0 .335.144.48.479.48.335 0 .479-.145.479-.48V.48Z' />
);

export const viewBox = '0 0 25 25';
